import {useCallback} from 'react';

import _ from 'topmeteo/utils/i18n';

import MarkSafe from 'topmeteo/general/components/MarkSafe';

const HelpText = _('To add new locations (via name or coordinates), please use the <i>SEARCH BAR</i>.');

const LocationManagerHelpText = ({onClose}) => {
    const handleClick = useCallback(
        event => {
            const locationSearchNode = document.getElementById('location-search');
            const inputNode = locationSearchNode.getElementsByClassName('form-element')[0];

            inputNode.focus();

            return onClose(event);
        },
        [onClose],
    );

    return (
        <MarkSafe
            Element="p"
            className="help-text"
            html={HelpText}
            onClick={handleClick}
        />
    );
};

export default LocationManagerHelpText;
